<template>
    <el-col :xs="22" :sm="22" :md="22" :lg="22" :xl="22">
        <el-card>
            <h1 style="margin-bottom: -8px; margin-top: -8px"> {{ $t('usersUpdate') }} </h1>
            <hr>
            <form>
                <div>
                    <InputField :label="$t('usersName')" 
                        :error="errors ? errors : ''" 
                        v-model="user.name"/>
                    <!-- <el-button v-if="isCurrentUser">
                        {{ $t('resetPasswordButton') }}
                    </el-button> -->
                </div>
                <shared-buttons discardPath="Users" :isEdit="true" @confirm-event-fired="save"/>
            </form>
        </el-card>
    </el-col>
</template>

<script>
    import api from '@/api/api';
    import { mapGetters, mapActions } from 'vuex';
    import { success } from '../Notification/notification';
    import InputField from '../Inputs/InputField'
    
    export default {
        components: {
            InputField
        },
        props: {
            isCurrentUser: {
                type: Boolean
            },
            user: {
                isRequired: true
            }
        },
        computed: {
            ...mapGetters({
                roles: 'getRoles'
            }),
            ...mapActions([
                'updateUser'
            ])
        },
        data () {
            return {
                errors: undefined,
                role: [],
                value: '',
                rolesData: []
            }  
        },
        methods: {
            success,
            save () {
                api.updateUser(this.user.id, { name: this.user.name })
                .then((res) => {
                    if (res.status === 201 || res.status === 200) {
                        this.success('User', 'updated');
                        this.$store.dispatch('updateUserData', this.user);
                        this.$router.push('/dashboard/users');
                    }
                })
                .catch((err)=>{
                    if (err.data.type === 'validation_error') {
                        this.errors = err.data.fields.name[0]
                    }
                })
            }
        }
    }
</script>

<style scoped>
    .block {
        display: inline-block;
    }

    .right {
        float: right;
    }

    .input-field {
        margin-top: 10px;
        margin-bottom: 10px;
    }

    .button {
        margin-left: 10px;
    }

    .error-msg {
        color: red;
        margin-bottom: 5px;
        display: block;
        margin-top: 3px;
    }

</style>



// WEBPACK FOOTER //
// src/components/Users/EditUserForm.vue